import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {XMLHttpRequestHandler} from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {header} from "./header";
import {interactionOverview_template} from "../components/templates/interactionOverview_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnAppZone } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone';

declare var ko: any;
declare var page: any;

export class interactionOverview extends vnModule_knockoutJS{

    protected interactionOverview_template: interactionOverview_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected indicatorPerformance: DOMHighResTimeStamp;
    protected detailPerformance: DOMHighResTimeStamp;
    protected zoneHeader: vnAppZone | null;

    /**
     * @inheritDoc
     */
    protected getModuleName(): string{

        return 'interactionOverview';
    }

    /**
     * @inheritDoc
     */
    public buildContent() : Array<Element>{

        this.zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = this.zoneHeader?.loadedModule;
        (<header>loadedModule).setHeaderTitle('Events Overview');

        this.interactionOverview_template = new interactionOverview_template('interactionOverview', this.viewModel, this)
        this.template = this.interactionOverview_template;

        return [this.interactionOverview_template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void {

        this.interactionOverview_template.buildDatePickerCalendar();

        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData(): void {

        this.loadingIn(this.interactionOverview_template.builtTemplate.querySelector("#report-results"));

        let subViewModel = this.interactionOverview_template.getViewModelForRequest();

        let usrReq_url: string = '/api/interaction_overview/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

        /**
     * Returns handler for filter request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onFilterRequestReturn(req, obj): Function{

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.updateFilters(responseParsed);

                obj.updateViewModelFromPath();

                obj.getReportStatus();

                obj.getSampledDates();

                obj.getIndicatorsByDateData();

                obj.getDetailedData();

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    // Every 100 report loads, display the Plan upgrade promotion (to free plan accounts only)
                    obj.zoneHeader?.loadedModule.showPlanPromo();

                    // LOADING : ends
                    obj.loadingOut(obj.interactionOverview_template.builtTemplate.querySelector("#report-results"));
                }
            }
        }
    }

    /**
     * Update the filters.
     *
     * @param responseParsed
     */
    protected updateFilters(responseParsed: any): void{

        this.interactionOverview_template.setDynamicFilters(responseParsed.dynamicFiltersData);
        this.interactionOverview_template.setBrandFilterItems(responseParsed.portfolios);
        this.interactionOverview_template.setDefaultDevices();
    }

    public resetIndicatorsData(): void{

        this.interactionOverview_template.clearIndicatorData();
        this.interactionOverview_template.setIndicatorDataLoaded(false);
        this.interactionOverview_template.clearTimelineAnnotatonData();

        this.loadingIn(this.interactionOverview_template.builtTemplate.querySelector("#indicatorsByDate-results"), true);
    }

    public getReportStatus(): void{

        let subViewModel = this.interactionOverview_template.getViewModelForRequest();
        let baseApiUrl = '/api/interaction_overview/reportStatus/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onReportStatusRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getReportStatus');
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onReportStatusRequestReturn(req, obj): Function{

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateReportStatusData(responseParsed);

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                }
            }
        }
    }

    public getSampledDates(): void{

        let subViewModel = this.interactionOverview_template.getViewModelForRequest();
        let baseApiUrl = '/api/interaction_overview/sampledDates/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onSampledDatesRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getSampledDates');
    }

    protected onSampledDatesRequestReturn(req, obj): Function{

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateSampledDatesData(responseParsed);

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                }
            }
        }
    }

    public getIndicatorsByDateData(): void{

        this.resetIndicatorsData();

        let subViewModel = this.interactionOverview_template.getViewModelForRequest();
        let baseApiUrl = '/api/interaction_overview/indicatorsByDate/get/';

        this.indicatorPerformance = performance.now();

        this.sendFilterCall(baseApiUrl, subViewModel, this.onIndicatorsByDateDataRequestReturn.bind(this, "dateRange"), XMLHttpRequestHandler_requestType.GET, 'getIndicatorsByDateData');
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onIndicatorsByDateDataRequestReturn(rangeType, req, obj): Function{

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if(rangeType == 'dateRange'){

                    obj.interactionOverview_template.setIndicatorDataLoaded(true);
                    obj.updateIndicatorsData(responseParsed);
                    obj.interactionOverview_template.updateIndicatorsGraphData();
                }

                var endTime = performance.now();

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    obj.loadingOut(obj.interactionOverview_template.builtTemplate.querySelector("#indicatorsByDate-results"), true);
                }
            }
        }
    }

    public getDetailedData(resetPagination = false): void{

        if (resetPagination) {
            
            this.interactionOverview_template.getTemplateViewModel().pagination.pageNumber(1);
        }

        this.loadingIn(this.interactionOverview_template.builtTemplate.querySelector("#dimensionsByDate-results"), true);

        let subViewModel = this.interactionOverview_template.getViewModelForRequest();
        let baseApiUrl = '/api/interaction_overview/dimensionsByDate/get/';

        this.detailPerformance = performance.now();

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDetailedDataRequestReturn.bind(this, baseApiUrl, 'getDetailedData'), XMLHttpRequestHandler_requestType.GET, 'getDetailedData');
    }

    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onDetailedDataRequestReturn(baseApiUrl, callIdentifier, req, obj): Function{

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                var endTime = performance.now()

                obj.interactionOverview_template.updatePagination(responseParsed.totalCount);
                obj.updateDetailedData(responseParsed.data);
                obj.setResultInfo(baseApiUrl, callIdentifier, responseParsed.totalCount, responseParsed.totalPage);

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    obj.loadingOut(obj.interactionOverview_template.builtTemplate.querySelector("#dimensionsByDate-results"), true);
                }
            }
        }
    }

    protected updateReportStatusData(responseParsed: any): void{

        this.interactionOverview_template.setReportStatusData(responseParsed.reportStatusData);
    }

    protected updateSampledDatesData(responseParsed: any): void{

        this.interactionOverview_template.setSampledDatesData(responseParsed.sampledDatesData);
    }

    protected updateDetailedData(data: any): void{

        this.interactionOverview_template.setDimensionsData(data.tableData, data.totals);
    }
    
    protected updateIndicatorsData(responseParsed: any): void{

        this.interactionOverview_template.setIndicatorsData(responseParsed.indicatorsData);
        this.interactionOverview_template.setTimelineAnnotationsData(responseParsed.timelineAnnotationsData);
    }

     /**
     * Hook.
     *
     * Initiates data refresh.
     */
     public filterDropdownOnChange(element): void{

        if(element=='brandFilter'){

            this.getReportStatus();
            this.getIndicatorsByDateData();
            this.getDetailedData(true);
        }
    }

    protected filterDateOnChange(element) {

        this.getReportStatus();
        this.getSampledDates();
        this.getIndicatorsByDateData();
        this.getDetailedData(true);
    }

    protected filterSimpleOnChange(){

        this.getReportStatus();
        this.getIndicatorsByDateData();
        this.getDetailedData(true);
    }

    protected filterMultipleSelectorOnChange(){

        this.getReportStatus();
        this.getIndicatorsByDateData();
        this.getDetailedData(true);
    }

    protected filterSingleGroupSelectorOnChange(element){

        if (element!='tableMetricFilter') {

            this.getReportStatus();
            this.getIndicatorsByDateData();
            this.getDetailedData(true);
        }else {

            this.getReportStatus();
            this.interactionOverview_template.updateViewMode();
        }
    }

    /**
     * Hook.
     *
     * Cancels data request.
     */
    protected filterSimpleCancel(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
        }
    }

    public getReportData(): void{

        this.getReportStatus();
        this.getIndicatorsByDateData();
        this.getDetailedData(true);

    }

    protected setResultInfo(baseApiUrl, callIdentifier, totalCount, totalPage){

        let callHdl = this.getXHRHdl(baseApiUrl, callIdentifier);

        let execTime = Math.round((new Date().getTime() - callHdl.requestStartTime)/1000*100)/100;
        this.interactionOverview_template.setResultPage(totalCount, totalPage, execTime);
    }

    public onQuit(){

        for(let callKey in this.XHRHdls){

            this.XHRHdls[callKey].cancelAndReset();
        }
    }

    private getXHRHdl(baseURl, callIdentifier){

        let callKey =   baseURl + '-' + callIdentifier;

        return this.XHRHdls[callKey];
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = this.interactionOverview_template.getViewModelForRequest();
        subViewModel['filters']['keyword'] = keyword;
        subViewModel['filters']['filterId'] = id;

        let usrReq_url = '/api/interaction_overview/autoCompleteSuggestions/get/';

        let usrReq_callback;
        usrReq_callback = this.onGetMultipleAutoCompleteSuggestionsReturn.bind(this, id);

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();    
    }

    protected onGetMultipleAutoCompleteSuggestionsReturn(filterId, req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){

                    (obj.interactionOverview_template.setDynamicAutoCompleteMultiSelectFilterItems(filterId, responseParsed.data));
                }
            });
        };

    }

    protected paginationOnPageClick(){

        this.getDetailedData();
    }

    public getListDataForCSV(): void{

        this.loadingIn(this.interactionOverview_template.builtTemplate.querySelector("#dimensionsByDate-results"));

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.interactionOverview_template.getViewModelForRequest();
        
        subViewModel['csvExport'] = true;
        
        let baseApiUrl = '/api/interaction_overview/dimensionsByDate/get/';
        
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        
        this.XHRHdl = new XMLHttpRequestHandler(baseApiUrl,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onCSVDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onCSVDataRequestReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.exportCsvData(responseParsed);

            });

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    obj.loadingOut(obj.interactionOverview_template.builtTemplate.querySelector("#dimensionsByDate-results"));
                }
            }
        }
    }

    protected exportCsvData(exportData): void{

        this.interactionOverview_template.setCsvExportData(exportData);
        this.interactionOverview_template.exportCsvData();
    }
}


// WEBPACK FOOTER //
// ./js/modules/interactionOverview.ts